import React from "react";
import pinImg from "../../assets/images/ic_pin_small.svg";
import starImg from "../../assets/images/star-24px.svg";
import NoImage from "../../assets/images/no-image.svg";
import Slider from "react-slick";
import tickMarkIcon from "../../assets/images/tick-mark.svg";
import SliderNextArrow from "../../components/slider/SliderNextArrow";
import SliderPrevArrow from "../../components/slider/SliderPrevArrow";
import { useHistory, Link } from "react-router-dom";
import accountImgMobile from "../../assets/images/account-mobile.png";
import { useSelector, useDispatch } from "react-redux";
import { homeAction } from "../../actions";
import Pagination from "../../components/pagination/pagination";

const FacilityList = ({
  activeFacility,
  facilities,
  total,
  currentPage,
  setCurrentPage,
  recordsPerPage,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  

  const { auth } = state; // Destructure auth from state
  const { authToken, isHost } = auth || {}; // Destructure authToken and isHost from auth

  const settings1 = {
    dots: true,
    infinite: true,
    speed: 300,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SliderNextArrow />,
    prevArrow: <SliderPrevArrow />,
  };

  const handleFacilityClick = (facilityId, facilityType) => {
    if (!isHost && authToken) {
      dispatch(
        homeAction.ppcClickBySignInUser({ facilityOrSoberLivingId: facilityId, facilityType: facilityType })
      );
    } 
    // else {
    //   dispatch(
    //     homeAction.ppcClickNonAuth({ facilityOrSoberLivingId: facilityId, facilityType: facilityType })
    //   );
    // }
  };



  return (
    <div className="container">
      {facilities && facilities?.length !== 0 ? (
        <>
          <div className="row">
            {facilities?.map((ele, id) => {
              return (
                <div className="col-md-6 col-xl-4" key={id}>
                  <Link
                    className="text-decoration-none"
                    to={{
                      pathname: `/${ele?.facilityType
                        }/${ele?.geocodingResult?.stateLong
                          ?.toLowerCase()
                          ?.replace(/\s+/g, "-")
                          .replace(/-$/, "")}/${ele?.name
                            ?.toLowerCase()
                            .replace(/,/g, "")
                            ?.replace(/\s+/g, "-")
                            .replace(/-$/, "")}`,
                    }}
                    onClick={() => handleFacilityClick(ele?.id, activeFacility)}
                  >
                    <div className="facility-list-item">
                      <div className="img-slider position-relative">
                        {ele?.subscriptionType === "pro" ||
                          ele?.subscriptionDetail?.subscriptionType === "pro" ? (
                          <Slider {...settings1}>
                            {ele?.photos?.length > 0 ? (
                              ele?.photos?.map((item, id) => {
                                return (
                                  <img
                                    loading="lazy"
                                    src={item?.path}
                                    className="img-fluid facility-img"
                                    alt={ele?.name}
                                    key={id}
                                  />
                                );
                              })
                            ) : (
                              <img
                                loading="lazy"
                                src={NoImage}
                                className="img-fluid facility-img"
                                alt="NoImage"
                              />
                            )}
                          </Slider>
                        ) : (
                          <Slider {...settings1}>
                            {ele?.photos?.length > 0 ? (
                              <img
                                loading="lazy"
                                src={ele?.photos[0]?.path}
                                className="img-fluid facility-img"
                                alt={ele?.name}
                              />
                            ) : (
                              <img
                                loading="lazy"
                                src={NoImage}
                                className="img-fluid facility-img"
                                alt={ele?.name}
                              />
                            )}
                          </Slider>
                        )}
                        {/* {(ele?.preSalePlanType === "pro" || ele?.subscriptionDetail?.subscriptionType === "pro") && <span className="subscription-msg unsubscribed">Featured</span>} */}
                        {ele?.isPPCSubscribed && (
                          <span className="promote-ad-msg">Ad</span>
                        )}
                      </div>
                      <div className="card-body">
                        <div className="card-heading_wraper d-flex align-items-center justify-content-between">
                          <div className="card-heading">
                            {ele?.name?.length > 30
                              ? ele?.name
                                ?.slice(0, 30)
                                ?.split(" ")
                                ?.map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase()
                                )
                                .join(" ") + "...."
                              : ele?.name
                                ?.split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase()
                                )
                                .join(" ")}
                            {ele?.isVerified && (
                              <img
                                src={tickMarkIcon}
                                className="img-fluid"
                                alt={ele?.name}
                              />
                            )}
                          </div>
                          {(ele?.isSubscribed || ele?.isPreSaleSubscribed) && (
                            <span className="location align-items-center">
                              <img
                                src={starImg}
                                className="img-fluid m-0"
                                alt="starImg"
                              />
                              {ele?.rating?.value !== 0 ? (
                                <>
                                  <span>{ele?.rating?.value.toFixed(1)}</span>
                                </>
                              ) : (
                                <>
                                  <span>0.0</span>
                                </>
                              )}
                            </span>
                          )}
                        </div>
                        <span className="location">
                          <img
                            src={pinImg}
                            className="img-fluid"
                            alt="location"
                          />
                          {ele?.geocodingResult?.cityName}
                          {", "}
                          {ele?.geocodingResult?.stateShort}
                          {", "}
                          {ele?.geocodingResult?.country}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
          <Pagination
            itemsPerPage={recordsPerPage}
            totalItems={total}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </>
      ) : (
        <div className="col-md-12">
          <div className="no-facilities">
            <p>NO FACILITIES LISTED…YET!</p>
            <img
              src={accountImgMobile}
              className="img-fluid"
              alt="accountImgMobile"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(FacilityList);
